import { Box } from '@mui/material';

import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface ReportDrillInLayoutProps {
    children: ReactNode;
}

/**
 * Summary cards share a 3-up row (16px gap).
 * One card stays a third of the row. Two and three cards have their own
 * ceiling so a wide page does not stretch them. Four or more are uncapped.
 */
export const reportSummaryMetricsSx = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    '& > *:only-child': {
        maxWidth: 'min(500px, calc((100% - 32px) / 3))',
    },
    '& > *:first-child:nth-last-child(2), & > *:first-child:nth-last-child(2) ~ *':
        {
            maxWidth: 'min(500px, calc((100% - 16px) / 2))',
        },
    '& > *:first-child:nth-last-child(3), & > *:first-child:nth-last-child(3) ~ *':
        {
            maxWidth: 'min(440px, calc((100% - 32px) / 3))',
        },
} satisfies SxProps<Theme>;

export const ReportDrillInMetrics = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            ...reportSummaryMetricsSx,
            marginBottom: '32px',
        }}
    >
        {children}
    </Box>
);

export const ReportDrillInSections = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
        }}
    >
        {children}
    </Box>
);
